<template>
  <div id="starnote">
      <b-input
        id="inline-form-input-name"
        class="mb-2 mr-sm-2 mb-sm-0 search"
        placeholder="搜索" v-model="keywords"
      ></b-input>

     <div class="article">
        <div class="content" v-for="(post, key) in search(keywords)">
            <a class="titleclass" @click="showChapter(key, post.permlink)">
                <img src="../../static/images/star.svg"  alt="StarNote">
                {{ post.title }} 　<p class="posttime">{{ post.created | formatTime}} </p></a> 　
            <b-button class="edittitle" variant="outline-primary" @click="edit(key, post)">编辑</b-button>

            <p v-show="!editFlag[key]">摘要：{{ JSON.parse(post.json_metadata).text }}</p>


            <!--显示主题编辑-->
            <div v-show="editFlag[key]">
                <div id="main">
                    <b-input
                            class="mb-2 mr-sm-2 mb-sm-0 title"
                            placeholder="请输入标题" v-model="title"
                    ></b-input>

                        <b-form-textarea
                                id="textarea"
                                v-model="text"
                                rows="3"
                                max-rows="6"
                        ></b-form-textarea>

                </div>

                <b-button variant="outline-primary" @click="refresh(key, post)">更新</b-button>
                <b-button variant="outline-primary" @click="editclear(key)">取消</b-button>
            </div>

            <!--显示章节内容-->
            <div v-show="flag[key]">
                <div v-for="(item, ckey) in chapters">
                    <!--子组件显示章节内容-->
                    <Replylist :parentmsg="item" :ckey="ckey"></Replylist>
                </div>

                <b-button  v-if="!addFlag" variant="outline-primary" @click="addChapter(post.author, post.permlink, post)">新增章节</b-button>
                <div v-if="addFlag">
                    <div id="main2">
                        <div class="subtitle">
                            <b-input
                                    class="mb-2 mr-sm-2 mb-sm-0 title"
                                    placeholder="请输入章节名" v-model="subtitle"
                            ></b-input>
                        </div>
                        <div id="main3">
                            <mavon-editor v-model="subtext" ref="md" @imgAdd="uploadimg" style="height: 100%"/>
                        </div>
                    </div>

                    <b-button variant="outline-primary" @click="postChapter(post.author, post.permlink, post)">提交</b-button>
                    <b-button variant="outline-primary" @click="clear">取消</b-button>
                </div>
            </div>


         </div>

     </div>

    <!--加载动画-->
    <transition name="fade">
      <loading v-if="isLoading"></loading>
    </transition>

  </div>
</template>

<script>
  import Loading from './Loading'
  import Replylist from './Replylist'
    export default {
      name: "Manage",
      data() {
        return {
            keywords: '',
            isLoading: true,
            flag:[],
            res: [],
            chapters: [],
            addFlag: false,
            editFlag: [],
            title:'',
            text:'',
            subtitle:'',
            subtext:'',
          }
      },
      methods: {
          edit(key, post){
              //因为是下标的形式，数据不会实时渲染！
              //要使用this.$set的形式来修改它的值，这样就可以实时渲染，以实现切换的效果了。
              this.$set(this.editFlag, key, !this.editFlag[key])
              let posts = this.$store.state.posts
              for(let i=0;i<posts.length;i++){
                  //将其它的隐藏掉
                  if(key != i){
                      this.$set(this.editFlag, i, false)
                  }
              }
              this.title = post.title
              this.text = JSON.parse(post.json_metadata).text
          },
          refresh(key, post){
              this.$set(this.editFlag, key, false)
              this.$set(post, "title", this.title)
              this.$set(post, "body", this.body)

              let wif = this.$store.state.password
              let author = this.$store.state.username
              let parentAuthor = ''
              let parentPermlink = 'starnote'
              let permlink = post.permlink
              let title = this.title
              let text = this.text
              let tags = JSON.parse(post.json_metadata).tags
              let tail = '\n -> 前往[星空笔记](https://starnote.github.io/#/starnote/@'+author+'/'+permlink+')'
              let body = text+tail
              let jsonMetadata = {"tags": tags, "dapp": "starnote", "format": "markdown", "text": text}

              //发布到本地数据库
              //把数据拼成一个JSON
              let newpost = {
                  "id": post.id,
                  "title": title,
                  "author": author,
                  "permlink": permlink,
                  "body": body,
                  "created": new Date().toISOString().split('.')[0],
                  "json_metadata": JSON.stringify(jsonMetadata)
              }
              this.putTitleDB(newpost)

              //发布到steem上
              this.postToSteem(wif, parentAuthor, parentPermlink, author, permlink, title, body, jsonMetadata)
          },
          putTitleDB(post){
              let db = this.$store.state.db
              const titleName = this.$store.state.username + 'title'
              //得到操作 'testTable' 表的事务对象
              let transaction = db.transaction([titleName], 'readwrite') //可读可写事务
              transaction.oncomplete = function (event) {
                  console.log("533,事务操作完成")
              }
              transaction.onerror = function (event) {
                  console.log("事务操作出错")
                  console.dir(event)
              }
              transaction.onsuccess = function (event) {
                  console.log('事务操作成功')
              }

              //从事务对象里得到表里的objectStore对象
              let objectStore = transaction.objectStore(titleName)
              objectStore.put(post)
          },
          editclear(key){
              this.$set(this.editFlag, key, false)
              this.title = this.body = ''
          },
          getSteemPosts(author, startPermlink, limit, posts) {
              //传入要查询的作者名，初始标签，一次查询的条数，初始化数组
              let startTime = "2019-12-11T06:40:27"
              let that = this
              return new Promise((resolve, reject) => {
                  let beforeDate = new Date().toISOString().split('.')[0]
                  that.steem.api.getDiscussionsByAuthorBeforeDate(author, startPermlink, beforeDate, limit, function (err, result) {
                      let newResult = []
                      result.forEach(post => {
                          if (post.permlink !== startPermlink) {
                              newResult.push(post)
                          }
                      })
                      posts = [...posts, ...newResult]
                      if (result.length > 0 && result[result.length - 1].created > startTime) {
                          that.getSteemPosts(author, result[result.length - 1].permlink, limit, posts)
                              .then(resolve)
                              .catch(reject)
                      } else {
                          resolve(posts)
                      }
                  })
              })
          },
          filterPosts(posts) {
              let res = []
              posts.forEach(item => {
                  let json = JSON.parse(item.json_metadata)
                  if (item.category === "starnote" && json.dapp === "starnote") {
                      res.push(item)
                  }
              })
              return res
          },
          savePosts(db, steemposts) {
              const titleName = this.$store.state.username + 'title'
              //得到操作 'testTable' 表的事务对象
              let transaction = db.transaction([titleName], 'readwrite') //可读可写事务
              return new Promise(resolve => {
                  transaction.oncomplete = function (event) {
                      console.log("111, 事务操作完成")
                      resolve()
                  }
                  transaction.onerror = function (event) {
                      console.log("事务操作出错")
                      console.dir(event)
                  }
                  transaction.onsuccess = function (event) {
                      console.log('222, 事务操作成功')
                  }
                  //从事务对象里得到表里的objectStore对象
                  let objectStore = transaction.objectStore(titleName)
                  for (let i = steemposts.length - 1; i > -1 ; i--) {
                      objectStore.add(steemposts[i])
                      // console.log(223, "添加成功")
                  }
              })
          },
          saveChapters(db, chapters, permlink) {
              const chapterName = this.$store.state.username + 'chapter'
              //得到操作 'testTable' 表的事务对象
              let transaction = db.transaction([chapterName], 'readwrite') //可读可写事务
              return new Promise(resolve => {
                  transaction.oncomplete = function (event) {
                      console.log("121, 事务操作完成")
                      resolve()
                  }
                  transaction.onerror = function (event) {
                      console.log("事务操作出错")
                      console.dir(event)
                  }
                  transaction.onsuccess = function (event) {
                      console.log('222, 事务操作成功')
                  }
                  //从事务对象里得到表里的objectStore对象
                  let objectStore = transaction.objectStore(chapterName)
                  for (let i = 0; i < chapters.length; i++) {
                      objectStore.add(chapters[i])
                      // console.log(223, "添加成功")
                  }
                  //设置初始化标记
                  let chapterFlag = permlink
                  localStorage.setItem(chapterFlag, 'starnote')
              })
          },
          search(keywords){
              let posts = this.$store.state.posts
              return posts.filter(item => {
                  if(item.title.includes(keywords)){
                      // console.log(166, '查到了！')
                      return item
                  }
              })
          },
          showChapter(key, permlink){
              //因为是下标的形式，数据不会实时渲染！
              //要使用this.$set的形式来修改它的值，这样就可以实时渲染，以实现切换的效果了。
              this.chapters = []
              this.$set(this.flag, key, !this.flag[key])
              let posts = this.$store.state.posts
              for(let i=0;i<posts.length;i++){
                  //将其它的隐藏掉
                  if(key != i){
                      this.$set(this.flag, i, false)
                  }
              }

              //获取章节
              let db = this.$store.state.db
              let author = this.$store.state.username
              let that = this

              //获取初始化标记
              let chapterFlag = permlink
              if(localStorage.getItem(chapterFlag) == null){
                  async function getSteemReplies(author, permlink, res=[]) {
                      //从steem上获取本主题所有的章节
                      let chapters = await that.steem.api.getContentRepliesAsync(author, permlink)
                      //过滤出是本作者的章节
                      let newChapters = []
                      if(chapters.length > 1){
                          chapters.forEach(item => {
                              if(item.author === author){
                                  newChapters.push(item)
                              }
                          })
                          that.chapters = newChapters
                          //存入数据库
                          await that.saveChapters(db, newChapters, permlink)
                      }else{
                          //设置初始化标记
                          localStorage.setItem(chapterFlag, 'starnote')
                      }

                  }
                  getSteemReplies(author, permlink)

              }else{
                  //从数据库取
                  console.log(566, "从数据库取")
                  let that = this
                  this.getAllChapters(db)
                      .then(res => {
                          res.forEach(item => {
                              if(item.parent_permlink === permlink){
                                  that.chapters.push(item)
                              }
                          })
                      })

              }
          },
          addChapter(){
              this.addFlag = true
              this.subtitle = this.subtext = ''
          },
          postChapter(parentAuthor, parentPermlink,  post){
              this.addFlag = false
              let wif = this.$store.state.password
              let author = this.$store.state.username
              let permlink = this.getstr()
              let title = this.subtitle
              let body = this.subtext
              let tags = ['starnote', 'cn']
              let jsonMetadata = {"tags": tags, "dapp": "starnote", "format": "markdown"}

              //把数据拼成一个JSON发布到前端
              let chapter = {
                  "parent_author": parentAuthor,
                  "parent_permlink": parentPermlink,
                  "title": title,
                  "author": author,
                  "permlink": permlink,
                  "body": body,
                  "created": new Date().toISOString().split('.')[0],
                  "json_metadata": JSON.stringify(jsonMetadata)
              }
              this.chapters.push(chapter)

              //发布到前端数据库
              let db = this.$store.state.db
              const chapterName = this.$store.state.username + 'chapter'
              let transaction = db.transaction([chapterName], 'readwrite') //可读可写事务
              transaction.oncomplete = function (event) {
                  console.log("233，事务操作完成")
              }
              transaction.onerror = function (event) {
                  console.log("事务操作出错")
                  console.dir(event)
              }
              transaction.onsuccess = function (event) {
                  console.log('事务操作成功')
              }
              //从事务对象里得到表里的objectStore对象
              let objectStore = transaction.objectStore(chapterName)
              objectStore.add(chapter)

              //发布到steem上
              this.postToSteem(wif, parentAuthor, parentPermlink, author, permlink, title, body, jsonMetadata)
          },
          clear(){
              this.addFlag = false
              this.editFlag = false
              this.text = ''
          },
          uploadimg(pos, $file){
              this.imgAdd(pos, $file)
          }
      },

      filters:{
        formatTime(data){
          return data.substring(0,10)
        }
      },

      components: {
        Loading,
        Replylist
      },

      mounted() {
          let _this = this
          let author = this.$store.state.username
          async function main(){
              if(author){
                  //如果已登录
                  if(_this.$store.state.posts == false) {
                      //第一次打开页面或是刷新
                      // console.log(566, '第一次打开页面或是刷新')
                      let db = await _this.initDatabase()
                      _this.$store.commit('saveDB',db)
                      let posts = await _this.getAllPosts(db)
                      //判断是否有笔记
                      if (posts.length > 0) {
                          //有笔记
                          _this.$store.commit('savePosts', posts.reverse())
                          //标记章节显示
                          for(let i=0; i<posts.length;i++){
                              _this.flag[i] = false
                          }
                          //标记章节编辑显示
                          for(let i=0; i<posts.length;i++){
                              _this.editFlag[i] = false
                          }

                          //同步主题
                          //取得最新主题的时间标记
                          let latestPostFlag = posts[0].created
                          let permlinkList = []
                          posts.forEach(item => {
                              permlinkList.push(item.permlink)
                          })
                          //从steem上获取最新笔记
                          let steemposts = await _this.getPostsFromSteem(author, null, 20, [], latestPostFlag)
                          let newres = _this.filterPosts(steemposts)
                          if (newres.length > 0) {
                              let newPosts = []
                              newres.forEach(item => {
                                  if(permlinkList.indexOf(item.permlink) === -1){
                                      //新笔记
                                      newPosts.push(item)
                                  }
                              })
                              if(newPosts.length > 0){
                                  await  _this.savePosts(db, newPosts)
                                  console.log(544, '添加新主题成功！')
                                  let posts2 = await _this.getAllPosts(db)
                                  _this.$store.commit('savePosts', posts2.reverse())
                                  //标记章节显示
                                  for(let i=0; i<posts2.length;i++){
                                      _this.flag[i] = false
                                  }
                                  //标记章节编辑显示
                                  for(let i=0; i<posts2.length;i++){
                                      _this.editFlag[i] = false
                                  }
                              }
                          }

                      }else{
                          //无笔记
                          //从steem上获取所有笔记并存入vuex
                          console.log(1289, '从steem上获取所有课程并存入vuex')
                          let startTime = "2019-12-11T06:40:27"
                          let steemposts = await _this.getPostsFromSteem(author, null, 20, [], startTime)
                          let newres = _this.filterPosts(steemposts)
                          if (newres.length > 0) {
                              _this.$store.commit('savePosts', newres)
                              await  _this.savePosts(db, newres)
                              console.log(514, '添加新主题成功！')

                              //标记章节显示
                              for(let i=0; i<newres.length;i++){
                                  _this.flag[i] = false
                              }
                              //标记章节编辑显示
                              for(let i=0; i<newres.length;i++){
                                  _this.editFlag[i] = false
                              }
                          }

                      }

                  }
              }else{
                  _this.$router.push({path: '/login'})
              }

              _this.isLoading = false
          }
          main()
      }
    }

</script>

<style scoped>
    #starnote{
        width: 80%;
        margin: 0 auto;
    }

  .article{
    margin-top: 1rem;
  }
  .posttime{
    font-size: 0.8rem;
    display: inline;
      margin-left: 0.5rem;
  }
  .content{
      /*background-color: gray;*/
    color: rgba(55,53,58,0.75);
    align: center;
    margin: 1rem auto;
    padding-top: 1rem;
    padding-bottom: 1rem;
    width: 70%;
    border-bottom: 1px solid #ddd;
  }

  .title{
      margin-top: 0.2rem;
      margin-bottom: 0.4rem !important;
      width: 60%;

  }
  .titleclass:hover{
      color: rgba(29,32,136,0.93);
      text-decoration: none;
  }
  a{
    color: rgba(55,53,58,0.75);
  }

  a:hover{
    color: rgba(29,32,136,0.93);
    text-decoration: none;
  }


  .search{
    margin: 1rem auto !important;
    width: 75%;
  }

  .edittitle{
      margin-left: 1rem;
      margin-bottom: 0.6rem;

      }


  .btn-outline-primary {
      color: rgba(55,53,58,0.75);
      display: inline;
      border-color: transparent;
      font-size: 0.7rem;
      margin-top: 0.5rem;
      margin-left: 0rem;
  }
  .btn-outline-primary:hover{
      background-color: transparent;
      color: darkcyan;
  }

    .subtitle{
        margin-bottom: 1rem;
    }
     #main3{
         height: 28rem;
     }

</style>
